import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=f2b6c33c&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=ts"
export * from "./notifications.vue?vue&type=script&lang=ts"
import style0 from "./notifications.vue?vue&type=style&index=0&id=f2b6c33c&prod&scoped=true&lang=css"
import style1 from "./notifications.vue?vue&type=style&index=1&id=f2b6c33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b6c33c",
  null
  
)

export default component.exports